export default "__VITE_ASSET__DuYPOXG$__"